import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

const iconMap: { [propName: string]: string } = {
    7002008: '\uf1ec'
};

const titleMap: { [propName: string]: string } = {
    7002001: '境外用车-出租车',
    7002002: '境外接机',
    7002003: '境外送机',
    7002004: '境外用车-机酒景点接送',
    7002005: '境外自由行',
    7002006: '境外自由行',
    7002007: '深港通',
    7002008: '按天包车',
    7002010: '境外打车'
};

interface Props {
    data: {
        carType: string;
        hasDate: boolean;
        fixTravelDate: string;
        freeTravel: string;
        productTitle: string;
        carInfo: string;
        date: string;
        aboardAddress: string;
        carTypeName: string;
        takeTime: string;
        returnTime: string;
        costTime: string;
        from: string;
        to: string;
        dateTimeInfo: string;
        orderType: string;
        _disable: boolean;
    };
}

class TransferCar extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };
        // icon
        newData.iconfont = iconMap[newData.orderType] || '\uf1e7';
        newData.iconColor = '#22bbe9';
        // title
        newData.title = newData.orderTitle || titleMap[newData.orderType] || '境外用车';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.fixPrice = utils.fixPrice(newData.pricePayed);

        newData.date = utils.buildDateTime(newData.date);
        newData.dateTimeInfo = formatDate(newData.date) || '';
        if (newData.freeTravel) {
            newData.carType = 'freeTravel';
            newData.hasDate = newData.freeTravel.date;
            newData.fixTravelDate =
                newData.hasDate && `使用时间 ${utils.buildDateTime(newData.freeTravel.date)}`;
        }
        // 自由行类型2
        if (/700200(6|7)/.test(newData.orderType)) {
            newData.carType = 'freeTravel2';
        }
        if (newData.orderType === 7002008) {
            newData.carType = 'dailyRental';
        }
        // 截止时间小黄条
        if (newData.payDeadline) {
            newData.deadlineNotice = `请于${newData.payDeadline}前完成支付`;
        }
        if (newData.deductDeadline) {
            newData.deadlineNotice = `系统将于${newData.deductDeadline}自动扣款`;
        }
        return newData;
    }

    public render() {
        const {
            data: {
                carType,
                hasDate,
                fixTravelDate,
                freeTravel,
                productTitle,
                carInfo,
                date,
                aboardAddress,
                carTypeName,
                takeTime,
                returnTime,
                costTime,
                from,
                to,
                dateTimeInfo,
                orderType,
                _disable
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        if (carType === 'freeTravel') {
            return (
                <View style={styles.left}>
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {freeTravel.productTitle}
                    </Text>
                    {Boolean(hasDate) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {`${fixTravelDate} (当地时间)`}
                        </Text>
                    )}
                </View>
            );
        }
        if (carType === 'freeTravel2') {
            return (
                <View style={styles.left}>
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {productTitle}
                    </Text>
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {carInfo}
                    </Text>
                    {Boolean(date) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {`${date}  (当地时间)`}
                        </Text>
                    )}
                </View>
            );
        }
        if (carType === 'dailyRental') {
            return (
                <View style={styles.left}>
                    {Boolean(productTitle) && (
                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                            {productTitle}
                        </Text>
                    )}
                    {Boolean(aboardAddress) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {`上车：${aboardAddress}`}
                        </Text>
                    )}
                    {Boolean(date) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {`${date}  (当地时间)`}
                        </Text>
                    )}
                    {Boolean(carTypeName) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {carTypeName}
                        </Text>
                    )}
                </View>
            );
        }
        if (orderType === 7002009) {
            return (
                <View style={styles.left}>
                    {Boolean(productTitle) && (
                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                            {productTitle}
                        </Text>
                    )}
                    {Boolean(takeTime || returnTime || costTime) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {`${takeTime ? `${takeTime}` : ''}${
                                takeTime && returnTime ? ' 至 ' : ''
                            }${returnTime ? `${returnTime}` : ''}${costTime ? ` ${costTime}` : ''}`}
                        </Text>
                    )}
                </View>
            );
        }
        return (
            <View style={styles.left}>
                {Boolean(dateTimeInfo) && (
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {dateTimeInfo}
                    </Text>
                )}

                {Boolean(from) && (
                    <View style={styles.rowWithIcon}>
                        <View style={[styles.dot, dateTimeInfo ? null : styles.mb6]} />
                        <Text style={[styles.newOrderSubTitle, styles.flex1]} numberOfLines={1}>
                            {from}
                        </Text>
                    </View>
                )}
                {Boolean(to) && (
                    <View style={styles.rowWithIcon}>
                        <View
                            style={[styles.dot, styles.dotDist, dateTimeInfo ? null : styles.mb6]}
                        />
                        <Text style={[styles.newOrderSubTitle, styles.flex1]} numberOfLines={1}>
                            {to}
                        </Text>
                    </View>
                )}
                {Boolean(carInfo) && (
                    <Text style={[styles.newOrderSubTitle, styles.ml14]} numberOfLines={1}>
                        {carInfo}
                    </Text>
                )}
            </View>
        );
    }
}

const formatDate = (date: string) => {
    let info = date.split(' ') || [];
    if (info && info.length > 0) {
        const [a, b, c, ...d] = info;
        info = [a, c, b, ...d];
    }
    return info.join(' ');
};

export default TransferCar;
